import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet, Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, ResolveStart, ResolveEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PlatformLoaderComponent } from './components/platform-loader/platform-loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, PlatformLoaderComponent],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ocr-prime-admin';
  isResolving = signal(false);

  private router = inject(Router);

  constructor() {
    this.router.events.subscribe(event => {
      if (event instanceof ResolveStart) {
        this.isResolving.set(true);
      }
      if (event instanceof ResolveEnd || event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.isResolving.set(false);
      }
    });
  }
}
